import Grid from '@mui/material/Grid';

import { useHasPreDiningExperienceFeatureFlag } from 'reservations/account/hooks/featureFlags';
import NotesFormField from 'reservations/form/components/NotesFormField';
import SpecialOccasionFormField from 'reservations/form/components/SpecialOccasionFormField';

export const BookingFields = () => {
  const hasPreDiningExperienceFeature = useHasPreDiningExperienceFeatureFlag();

  return (
    <>
      {!hasPreDiningExperienceFeature && (
        <Grid item>
          <SpecialOccasionFormField />
        </Grid>
      )}
      <Grid item>
        <NotesFormField />
      </Grid>
    </>
  );
};
